import { IHttpClient } from '@wix/http-client';

export let httpClient: IHttpClient;

export function initHttpClient(newHttpClient) {
  httpClient = newHttpClient;
  return httpClient;
}
